import { Controller } from "@hotwired/stimulus"
import { openHighlightModal } from "../utils/highlight_modal"

export default class extends Controller {
  rememberTouch(event) {
    const touch = event.touches?.[0]
    if (!touch) return

    this.touchStartX = touch.clientX
    this.touchStartY = touch.clientY
  }

  open(event) {
    if (this.shouldIgnoreOpen(event)) return

    if (event?.cancelable) event.preventDefault()
    event?.stopPropagation()

    openHighlightModal(this.element)
  }

  shouldIgnoreOpen(event) {
    if (event?.type !== "touchend") return false

    const touch = event.changedTouches?.[0]
    if (!touch) return false

    const dx = Math.abs(touch.clientX - (this.touchStartX ?? touch.clientX))
    const dy = Math.abs(touch.clientY - (this.touchStartY ?? touch.clientY))
    return dx > 12 || dy > 12
  }
}
